/**
 * @deprecated
 * 控件基类，继承于组件基类；
 */
'use strict';
define([
    './ComponentBase',
    './BeanManagable',
    '../utils/CommonUtil',
    '../utils/ResourceUtil'
], function (
    ComponentBase,
    BeanManagable,
    CommonUtil,
    ResourceUtil
) {
    /**
     * 构造函数
     * @ignore
     * @constructor
     * @classdesc 控件基类
     * @alias G.base.ControlBase
     * @augments G.base.ComponentBase
     * @param {Object} options - 必填，构造参数
     * @param {String} options.id - 必填，唯一标识
     * @param {G.Map} options.map - 必填，地图对象
     * @param {String} options.staticPath - 可选，公共资源路径
     * @param {String} options.resourcePath - 可选，控件包目录如./controls/DemoCtrl/；
     * 如果设置，则cssPath/configPath/htmlPath/imgPath的默认相对目录为此值；
     * 默认为工程里的固定目录。
     * @param {String} options.cssPath - 可选，样式目录，默认为控件包下的css目录
     * @param {String} options.configPath - 可选，配置文件目录，默认为控件包下的config目录
     * @param {String} options.imgPath - 可选，图片目录，默认为控件包下的img目录
     * @param {String} options.htmlPath - 可选，静态html目录，默认为控件包下的html目录
     * @param {String} options.config - 可选，配置文件名，其目录相对options.configPath
     * @returns {Class} 实例化对象
     */
    var control = ComponentBase.extend({
        //默认配置项
        options: {
            style: {},
            dragable: false,
            //一下路径都可以实例化时灵活设置
            //公共静态资源路径
            staticPath:'',
            //样式目录
            cssPath:'',
            //配置文件目录
            configPath:'',
            //图片目录
            imgPath:'',
            //静态html目录
            htmlPath:'',
            //控件资源目录如./controls/DemoCtrl/
            resourcePath:''
        },
        //类型标识
        TYPE:"Control",
        initialize: function (options) {
            ComponentBase.prototype.initialize.call(this, options);
        },
        /**
         * 添加显示
         * @method
         * @memberOf G.base.ControlBase.prototype
         */
        onAdd: function () {
            try{
                this.onRemove();
            }catch (e){}
        },
        /**
         * 移除显示
         * @method
         * @memberOf G.base.ControlBase.prototype
         */
        onRemove: function () {},
        /**
         * 销毁
         * @method
         * @memberOf G.base.ControlBase.prototype
         */
        destroy: function () {
            //
            this.onRemove();
            //
            ComponentBase.prototype.destroy.call(this);
        }
    });


    /**
     *
     */
    control.include({
        getResourcePath:function(){
            if(!this._resourcePath){
                var name=this.options.name||'Anonymous';
                if(!name.endsWith('Ctrl')){
                    name+='Ctrl';
                }
                this._resourcePath= ResourceUtil.getControlPath(name);
            }
            return this._resourcePath;
        },
        setResourcePath:function(path){
            if(path){
                //处理多余的斜杠
                this._resourcePath=(path+'').replace(/([\/\\]+)/g,'/');
                if(!this._resourcePath.endsWith('/')){
                    this._resourcePath=this._resourcePath+'/';
                }
            }else{
                this._resourcePath=null;
            }
        }
    });
    //
    BeanManagable.enable(control);
    return control;
})